import angular from "angular";
import uiRouter from "angular-ui-router";
import ocLazyLoad from 'oclazyload';
import { attachAppUpdateTransitions } from "./app-update-transitions";
import { HardReloadService } from "./hard-reload.service";
import { RouterHelperProvider } from './router-helper.provider';
import { configureRouting } from "./routing.config";


export const RouterModule = angular
    .module("blocks.router", [
        uiRouter,
        ocLazyLoad as string
    ])
    .provider("routerHelper", RouterHelperProvider)
    .service("hardReloadService", HardReloadService)
    .config(configureRouting)
    .run(attachAppUpdateTransitions)
    .name;
